<div>
<!--  <app-sentence-generator></app-sentence-generator>-->
<!--  <app-details></app-details>-->
<!--  <app-voice-recorder></app-voice-recorder>-->
  <router-outlet></router-outlet>
</div>
